import { HTTPError } from 'ky';

import type { ClientCategorisation } from '@/constants';
import { fastApi } from '@/services/api';

const PATH = 'v1/customer/form/client-categorisation-treatment';

export type ClientCategorisationTreatmentAnswers = {
  treatment: ClientCategorisation;
};

type ClientCategorisationTreatmentQuestionnaireGetResponse = {
  answers: ClientCategorisationTreatmentAnswers;
  d: string;
};

export const getClientCategorisationTreatmentQuestionnaire = async () => {
  return fastApi
    .get(PATH)
    .json<ClientCategorisationTreatmentQuestionnaireGetResponse>()
    .catch((error) => {
      if (error instanceof HTTPError && error.response.status === 404) return null;

      throw error;
    });
};

export type ClientCategorisationTreatmentQuestionnairePostRequestBody = {
  answers: ClientCategorisationTreatmentAnswers;
  reprocessFuturesEligibility?: boolean;
};

export const postClientCategorisationTreatmentQuestionnaire = async ({ answers, reprocessFuturesEligibility }: ClientCategorisationTreatmentQuestionnairePostRequestBody) => {
  await fastApi.post(PATH, {
    json: {
      answers,
      ...(typeof reprocessFuturesEligibility === 'boolean' ? { reprocessFuturesEligibility } : null),
    },
  });
};
